import React                     from 'react';
import { Link }                  from 'react-router-dom';
import { Observe }               from 'rewire-core';
import { WithStyle, withStyles } from 'rewire-ui';
import { makeStyles, Theme }     from '@material-ui/core/styles';
import RoutedEntityListModel     from './RoutedEntityListModel';
import EntityListCardView, {
  IEntityListCardViewProps,
  IItemRendererProps,
  DefaultItemRenderer,
}                                from './EntityListCardView';
export type { IItemRendererProps };

const routedEntityItemRendererStyles = (_theme: Theme) => ({
  link: {
    padding: '8px',
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    textDecoration: 'none',
  },
});

const useRoutedEntityItemRendererStyles = makeStyles(routedEntityItemRendererStyles);

export interface IRoutedEntityItemRendererProps extends Omit<IItemRendererProps, 'model'> {
  model: RoutedEntityListModel;
}

export const getRoutedEntityItemRenderer = (itemRenderer?: React.FunctionComponent<IItemRendererProps>) => ({model, entity, classes}: IRoutedEntityItemRendererProps) => {
  const useClasses               = useRoutedEntityItemRendererStyles({classes});
  const { link, ...restClasses } = useClasses;
  const ItemRenderer             = itemRenderer || DefaultItemRenderer;
  const linkAddress              = model.makeLink(entity.id);
  const handleClickLink          = (e: any) => {
    // If the target has not changed, don't bother processing it
    if (e.target.href === location.href) e.preventDefault();
  };
  return (
    <Observe render={() => {
      return (
        <Link className={link} to={linkAddress} onClick={handleClickLink}>
          <ItemRenderer model={model} entity={entity} classes={restClasses} />
        </Link>
      );
    }} />
  );
};

const styles = (_theme: Theme) => ({
  wrapper: {
  },
  card: {
  },
  itemContainer: {
    padding: '0px',
  },
  selected: {
  },
  notSelected: {
  },
});

export type RoutedEntityListCardViewStyles = ReturnType<typeof styles>;

export interface IRoutedEntityListCardViewProps extends Omit<IEntityListCardViewProps, 'model'> {
  model: RoutedEntityListModel;
}

export type RoutedEntityListCardViewProps = WithStyle<RoutedEntityListCardViewStyles, IRoutedEntityListCardViewProps>;

export class RoutedEntityListCardView extends React.Component<RoutedEntityListCardViewProps> {
  constructor(props: RoutedEntityListCardViewProps) {
    super(props);
  }

  render() {
    const { itemRenderer, ...restProps } = this.props;
    const ItemRenderer = getRoutedEntityItemRenderer(itemRenderer);

    return <Observe render={() => {
      return (
        <EntityListCardView itemRenderer={ItemRenderer} {...restProps} />
      );
    }} />;
  }
}

export default withStyles(styles, RoutedEntityListCardView);
